module.exports = __webpack_public_path__ + "img/icon_gys.3877ea58.png";